$IndexClass= jhc.Class.IndexClass;
console.dir($IndexClass);
const slideTarget= document.getElementsByClassName('img-slide-wrap')

_jh.each( slideTarget, function (i, v) {
	console.dir(this);
	const target= this.getElementsByClassName('image-slide')
			,	bullet= this.getElementsByClassName('bullets');
	$IndexClass.rollingEvt($(target), $(bullet), true, true);
});